import React from 'react';

export default function StationQualification({ station }) {
  if (!station) return <p>Interval qualification audit pending.</p>;
  if (station.status === 'failed') return <p role="status">Station qualification check failed: {station.error}</p>;
  return <section aria-label={`Interval qualification for ${station.id}`}>
    <h4>Interval checks · Review required</h4>
    <p>{station.totals.usableDays} / {station.totals.expectedDays} days match the benchmark interval rules. Training and resort qualification remain pending.</p>
    {!!station.findings.length && <ul>{station.findings.map(finding => <li key={finding}>{finding}</li>)}</ul>}
    <div className="rekkie-snow-table-wrap"><table>
      <thead><tr><th>Winter</th><th>Usable intervals</th><th>Snow / dry</th><th>Excluded</th></tr></thead>
      <tbody>{station.winters.map(winter => <tr key={winter.winter}>
        <th scope="row">{winter.winter}</th><td>{winter.usableDays} / {winter.expectedDays}</td>
        <td>{winter.snowDays} / {winter.dryDays}</td><td>{winter.excludedDays}</td>
      </tr>)}</tbody>
    </table></div>
    <details><summary>Exclusions and required review</summary>
      <p>First exclusion reason per day. Snow and dry counts include usable intervals only.</p>
      <ul>{Object.entries(station.totals.reasons).map(([reason, count]) => <li key={reason}>{reason}: {count}</li>)}</ul>
      <p>Longest uninterrupted usable period: {station.totals.longestUsableStreak} days.</p>
      <p>Required station review</p>
      <ul>{station.pendingReview.map(item => <li key={item}>{item}</li>)}</ul>
    </details>
  </section>;
}
